import { SettingOutlined } from "@ant-design/icons";
import { Button, Modal, message } from "antd";
import { useEffect, useState } from "react";
import "./NotificationCenter.css";
import NotificationRuleTable from "./NotificationRuleTable/NotificationRuleTable";

import { useSelector } from "react-redux";
import {
  CreateNotificationRule,
  DeleteNotificationRule,
  GetNotificationRuleList,
  UpdateNotificationRule,
} from "../../../services/common/cnc_apis";
import lang from "../../../services/lang";
import NotificationRuleDialog from "./NotificationRuleDialog/NotificationRuleDialog";

function NotificationCenter(props) {
  const { langIndex } = useSelector((state) => state.app);
  const authData = useSelector((state) => state.authService);
  const { showModal, setShowModal, selCustomerId, customerInfo } = props;
  const [isShowModal, setIsShowModal] = useState(false);
  const [ruleList, setRuleList] = useState([]);
  const [initRuleInfo, setInitRuleInfo] = useState(null);

  useEffect(() => {
    if (showModal && selCustomerId) {
      GetNotificationRuleList(selCustomerId, (ruleList) => {
        if (ruleList != null && ruleList.length > 0) {
          ruleList.forEach(function (entry) {
            entry.key = entry.id;
          });
          setRuleList(ruleList);
        } else {
          setRuleList([]);
        }
      });
    }
  }, [showModal, selCustomerId]);

  const deleteRule = (id) => {
    DeleteNotificationRule({ customer_id: selCustomerId, id: id }, (res) => {
      if (res == true) {
        const newData = ruleList.filter((element) => element.id != id);
        setRuleList(newData);
        message.success(lang(langIndex, "msg_delete_success"));
      } else {
        message.error(lang(langIndex, "msg_something_wrong"));
      }
    });
  };

  const onClickEditRecord = (record) => {
    setInitRuleInfo(record);
    setIsShowModal(true);
  };

  const onClickAddRule = () => {
    setInitRuleInfo(null);
    setIsShowModal(true);
  };

  const addRule = (info) => {
    info["customer_id"] = selCustomerId;
    // Add created_by_user_id from current logged-in user
    if (authData && authData.user_id) {
      info["created_by_user_id"] = authData.user_id;
    }

    CreateNotificationRule(info, (res) => {
      if (res != null) {
        res.key = res.id;
        setRuleList([...ruleList, res]);
        message.success(lang(langIndex, "msg_add_success"));
        setIsShowModal(false);
      } else {
        message.error(lang(langIndex, "msg_something_wrong"));
      }
    });
  };

  const editRule = (info) => {
    info["customer_id"] = selCustomerId;
    const newData = [...ruleList];
    const index = newData.findIndex((item) => item.key === info.key);
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1, { ...item, ...info });
      UpdateNotificationRule(info, (res) => {
        if (res != null) {
          res.key = res.id;
          newData[index] = res;
          setRuleList(newData);
          message.success(lang(langIndex, "msg_update_success"));
          setIsShowModal(false);
        } else {
          message.error(lang(langIndex, "msg_something_wrong"));
        }
      });
    } else {
      message.error(lang(langIndex, "msg_something_wrong"));
    }
  };

  const onCancel = () => {
    setShowModal(false);
  };

  return (
    <Modal
      centered
      visible={showModal}
      title={null}
      onCancel={() => onCancel()}
      onOk={() => onCancel()}
      okText={lang(langIndex, "plant_update")}
      closable={true}
      className="customer-setting-dialog-style"
      destroyOnClose={true}
      footer={null}
      width={1200}
    >
      <div className="customer-setting-page-title">
        <SettingOutlined />
        <span style={{ marginLeft: 10 }} />
        {lang(langIndex, "notification_center_title")}
      </div>

      <div
        className="content-scrollbar-style user-setting-container"
        style={{ overflow: "auto" }}
      >
        {isShowModal === true && (
          <NotificationRuleDialog
            initRuleInfo={initRuleInfo}
            addRule={addRule}
            editRule={editRule}
            isShowModal={isShowModal}
            setIsShowModal={setIsShowModal}
            selCustomerId={selCustomerId}
          />
        )}
        <div className="user-setting-button-container">
          <Button
            ghost
            onClick={() => {
              onClickAddRule();
            }}
          >
            {lang(langIndex, "notification_rule_add_new")}
          </Button>
        </div>
        <div className="user-setting-user-table-style">
          <NotificationRuleTable
            ruleList={ruleList}
            deleteRule={deleteRule}
            onClickEditRecord={onClickEditRecord}
            selCustomerId={selCustomerId}
          />
        </div>
      </div>
    </Modal>
  );
}

export default NotificationCenter;

